import {
  Collapse,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import MDBadgeDot from "components/MDBadgeDot";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { COMPETITION_WIN_CONDITIONS } from "lib/constants";
import React, { useEffect, useState } from "react";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";

function UserKpiRow({ competition, user, selectedUser }) {
  const [usersWithKpis, setUsersWithKpis] = useState([]);

  useEffect(() => {
    setUsersWithKpis(selectedUser?.kpisWithCounts || []);
  }, [selectedUser]);

  return (
    <TableCell sx={{ p: 0, background: "#f3f3f3" }} colSpan={8} className="user-list-cell">
      <Collapse in={user?.id === selectedUser?.id} timeout="auto" unmountOnExit>
        <MDBox m={2} sx={{ display: "flex", justifyContent: "center" }}>
          <TableContainer sx={{ width: "100%", position: "relative" }}>
            <Table>
              <TableHead sx={{ display: "table-header-group" }}>
                <TableRow>
                  <TableCell className="listing-table-header">KPI</TableCell>
                  {competition?.CompetitionWinCondition?.condition ===
                  COMPETITION_WIN_CONDITIONS.TOTAL_POINTS ? (
                    <>
                      <TableCell className="listing-table-header">Completed</TableCell>
                      <TableCell className="listing-table-header">Points</TableCell>
                    </>
                  ) : (
                    <TableCell className="listing-table-header">Total</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {usersWithKpis.map((usersWithKpi) => (
                  <TableRow key={usersWithKpi.id}>
                    <TableCell>
                      <Grid container>
                        <MDBadgeDot
                          color="warning"
                          size="lg"
                          sx={{
                            p: 0.5,
                            i: {
                              background: generateColorFromString(usersWithKpi?.kpiActionName),
                            },
                          }}
                          badgeContent=""
                        />
                        <MDTypography>{usersWithKpi?.kpiActionName}</MDTypography>
                      </Grid>
                    </TableCell>
                    {competition?.CompetitionWinCondition?.condition ===
                    COMPETITION_WIN_CONDITIONS.TOTAL_POINTS ? (
                      <>
                        <TableCell>
                          <MDTypography>{usersWithKpi?.count}</MDTypography>
                        </TableCell>
                        <TableCell>
                          <MDTypography>{usersWithKpi?.points}</MDTypography>
                        </TableCell>
                      </>
                    ) : (
                      <TableCell>
                        <MDTypography>{usersWithKpi?.count}</MDTypography>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
      </Collapse>
    </TableCell>
  );
}

export default UserKpiRow;
